import provider from './SSRDataProvider';

export default provider;
